import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const steamLoginUrl = `${API_BASE}/auth/steam/login`;

export const SITE = {
  serverName: "RiverSide Roleplay",
  serverIp: "45.43.163.41:5520",
  connectUrl: "steam://connect/45.43.163.41:5520",
  discordUrl: "https://discord.gg/BWzd76XSd9",
  boutiqueUrl: "https://boutiquersrp.tip4serv.com/",
  logoUrl: "https://customer-assets-gfyr7b9c.emergentagent.net/job_side-roleplay/artifacts/dmkl06ix_image.png",
};
